export default __webpack_public_path__ + "static/history-b005cd42f6280d3e535425a9cd58568a.png";